import { render, staticRenderFns } from "./CriarUnidadeGestora.vue?vue&type=template&id=1a9e99a8"
import script from "./CriarUnidadeGestora.vue?vue&type=script&lang=ts"
export * from "./CriarUnidadeGestora.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports